import React from 'react';
import {Alert, Snackbar} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../redux/store';
import {hideNotification} from '../redux/reducers/notificationReducer';

const NotificationHandler = () => {
    const dispatch = useDispatch();
    const {open, message, severity} = useSelector((state: RootState) => state.notification);

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(hideNotification());
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        >
            <Alert onClose={handleClose} severity={severity} sx={{width: '100%'}} variant="filled">
                {message}
            </Alert>
        </Snackbar>
    );
};

export default NotificationHandler;
